export const formatChatTimestamp = (input: string | Date): string => {
  const messageDate = typeof input === "string" ? new Date(input) : input;
  if (Number.isNaN(messageDate.getTime())) {
    return "";
  }

  const now = new Date();

  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };
  const timeStr = messageDate.toLocaleTimeString(undefined, timeOptions);

  const isToday = messageDate.toDateString() === now.toDateString();
  if (isToday) {
    return timeStr;
  }

  const dateOptions: Intl.DateTimeFormatOptions = { month: "numeric", day: "numeric" };
  const dateStr = messageDate.toLocaleDateString(undefined, dateOptions);
  return `${dateStr} ${timeStr}`;
};
